import { Field } from "formik";
import { stateProvince } from "../../../utility/state-province";
import { DatePickerInput } from "../../datepicker-input";
import StateProvinceDropdown from "../../stateprovinceDropdown";


const IntakeDMVDetailsFields = ({ errors, touched, values, nested }) => {
    return (
        <div className="form-wrapper general-information">
            <h3>Subject</h3>

            <div className="form-row">
                <div className="form-field-wrapper">
                    <label htmlFor="firstName">First Name <span className="required">*</span></label>
                    <Field id="firstName" name={nested ? "dmvDetails.firstName" : "firstName"} />

                    {errors && errors.firstName && touched && touched.firstName ? (
                        <div className="form-error">{errors.firstName}</div>
                    ) : null}
                </div>

                <div className="form-field-wrapper">
                    <label htmlFor="lastName">Last Name <span className="required">*</span></label>
                    <Field id="lastName" name={nested ? "dmvDetails.lastName" : "lastName"} />

                    {errors && errors.lastName && touched && touched.lastName ? (
                        <div className="form-error">{errors.lastName}</div>
                    ) : null}
                </div>

                <div className="form-field-wrapper">
                    <label htmlFor="lastKnownAddress1">Last Known Address 1</label>
                    <Field id="lastKnownAddress1" name={nested ? "dmvDetails.lastKnownAddress1" : "lastKnownAddress1"} />
                </div>

                <div className="form-field-wrapper">
                    <label htmlFor="lastKnownAddress2">Last Known Address 2</label>
                    <Field id="lastKnownAddress2" name={nested ? "dmvDetails.lastKnownAddress2" : "lastKnownAddress2"} />
                </div>

                <div className="form-field-wrapper">
                    <label htmlFor="city">City</label>
                    <Field id="city" name={nested ? "dmvDetails.city" : "city"} />
                </div>

                <StateProvinceDropdown nested={nested} values={values} stateProvince={stateProvince} name={nested ? "dmvDetails.stateProvince" : "stateProvince"} id="stateProvince" disabled={false}/>

                <div className="form-field-wrapper">
                    <label htmlFor="zip">Zip</label>
                    <Field id="zip" name={nested ? "dmvDetails.zip" : "zip"} />
                </div>

                <div className="form-field-wrapper">
                    <label htmlFor="country">Country</label>
                    <Field id="country" name={nested ? "dmvDetails.country" : "country"} />
                </div>
            </div>

            <div className="form-row">
                <div className="form-field-wrapper">
                    <label htmlFor="dob">Date of Birth</label>
                    <DatePickerInput name={nested ? "dmvDetails.dob" : "dob"} placeholderText="Select date" />
                </div>

                <div className="form-field-wrapper">
                    <label htmlFor="age">Age</label>
                    <Field id="age" name={nested ? "dmvDetails.age" : "age"} />
                </div>

                <div className="form-field-wrapper">
                    <label htmlFor="vin">VIN</label>
                    <Field id="vin" name={nested ? "dmvDetails.vin" : "vin"} />
                </div>

                <div className="form-field-wrapper">
                    <label htmlFor="licensePlate">License Plate</label>
                    <Field id="licensePlate" name={nested ? "dmvDetails.licensePlate" : "licensePlate"} />
                </div>

                <div className="form-field-wrapper">
                    <label htmlFor="licenseNumber">Driver's License Number</label>
                    <Field id="licenseNumber" name={nested ? "dmvDetails.licenseNumber" : "licenseNumber"} />
                </div>
            </div>
            <div className="mb-5">
                <div role="group" aria-labelledby="dmv-radio-group" className="">
                    <div className="form-check mb-2">
                        <Field type="checkbox" name={nested ? 'dmvDetails.dmvRequest' : 'dmvRequest'} value="License Plate/Vin Search" id="License Plate/Vin Search" />
                        <label htmlFor="License Plate/Vin Search"><strong>License Plate / Vin Search</strong></label>
                    </div>
                    <div className="form-check mb-2">
                        <Field type="checkbox" name={nested ? "dmvDetails.dmvRequest" : "dmvRequest"} value="DL Search" id="DL Search" />
                        <label htmlFor="DL Search"><strong>DL Search</strong></label>
                    </div>
                    <div className="form-check mb-2">
                        <Field type="checkbox" name={nested ? "dmvDetails.dmvRequest" : "dmvRequest"} value="ANI Search" id="ANI Search" />
                        <label htmlFor="ANI Search"><strong>ANI Search:</strong> An ANI (Alpha Name Index) search will identify all vehicles currently registered to a specific individual at a specific address. This search is only available in California.</label>
                    </div>
                    <div className="form-check mb-2">
                        <Field type="checkbox" name={nested ? "dmvDetails.dmvRequest" : "dmvRequest"} value="Photo History" id="Photo History" />
                        <label htmlFor="Photo History"><strong>Photo History:</strong> A photo history contains photocopies of all documents submitted to the DMV to change ownership of a vehicle. They are ordered by year and normally available only for: change of ownership, release of liability, and salvage certificate.</label>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IntakeDMVDetailsFields;